<template>
  <div
    :style="`background-color: ${props.color}`"
    class="frame horizontal upper left"
  />
  <div
    :style="`background-color: ${props.color}`"
    class="frame vertical upper left"
  />
  <div
    :style="`background-color: ${props.color}`"
    class="frame horizontal upper right"
  />
  <div
    :style="`background-color: ${props.color}`"
    class="frame vertical upper right"
  />

  <div
    :style="`background-color: ${props.color}`"
    class="frame horizontal lower left"
  />
  <div
    :style="`background-color: ${props.color}`"
    class="frame vertical lower left"
  />
  <div
    :style="`background-color: ${props.color}`"
    class="frame horizontal lower right"
  />
  <div
    :style="`background-color: ${props.color}`"
    class="frame vertical lower right"
  />
</template>

<script setup>
const props = defineProps({
  color: {
    type: String,
    default: 'rgb(0,0,0)',
    required: true,
  },
});
</script>

<style scoped>
.frame {
  position: absolute;
}

.frame.horizontal {
  width: 20px;
  height: 5px;
}
.frame.vertical {
  width: 5px;
  height: 20px;
}

.frame.upper {
  top: 0px;
}
.frame.lower {
  bottom: 0px;
}

.frame.left {
  left: 0px;
}
.frame.right {
  right: 0px;
}
</style>
